import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

interface ConfirmModalProps {
  show: boolean;
  title: string;
  message: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalDelete: React.FC<ConfirmModalProps> = ({
  show,
  title,
  message,
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header
        closeButton
        style={{ background: "var(--color-profile-1)", color: "black" }}
      >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={loading}
          onClick={onCancel}
          style={{ display: "flex", alignItems: "center" }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            "Cancelar"
          )}
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={loading}
          onClick={onConfirm}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            "Confirmar"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
